export default __webpack_public_path__ + "static/media/Animations_Clock4.6d3a7ca8.svg";